var _path, _circle, _path2, _circle2, _path3, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCompanySize = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.667,
    d: "M15.145 15.629c-.304-.85-.973-1.602-1.905-2.138-.931-.536-2.072-.827-3.247-.827s-2.315.29-3.246.827c-.932.536-1.601 1.287-1.905 2.138"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.991,
    cy: 7.331,
    r: 2.667,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.25,
    d: "M7.12 13.387c-.164-.46-.527-.868-1.031-1.158a3.56 3.56 0 0 0-1.759-.448c-.636 0-1.254.158-1.758.448-.505.29-.868.697-1.032 1.158"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.331,
    cy: 8.89,
    r: 1.444,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.25,
    d: "M18.453 13.387c-.165-.46-.527-.868-1.032-1.158a3.56 3.56 0 0 0-1.759-.448c-.636 0-1.254.158-1.758.448-.505.29-.867.697-1.032 1.158"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.663,
    cy: 8.89,
    r: 1.444,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.25
  })));
};
export default SvgCompanySize;